import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Slider } from "@/components/ui/slider";
import { ArrowRight, Trophy } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const QUESTIONS = [
  { key: "achieved", label: "¿Consideras que has alcanzado tus 3 objetivos SMART?" },
  { key: "achievements", label: "¿Qué logros específicos has alcanzado?" },
  { key: "obstacles", label: "¿Cuáles fueron los principales obstáculos que enfrentaste?" },
  { key: "strategies", label: "¿Qué estrategias utilizaste para superarlos?" },
  { key: "useful", label: "¿Qué aspectos del programa te resultaron más útiles?" },
  { key: "lessons", label: "¿Qué lecciones has aprendido?" },
  { key: "future", label: "¿Cómo aplicarás lo aprendido en tu día a día?" },
];

export default function FinalReviewStep({ sessionNumber, onDone }) {
  const [data, setData] = useState({ satisfaction: 8 });
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (Object.values(data).filter(v => typeof v === "string" ? v.trim() : true).length < 3) {
      toast.error("Responde al menos 2 preguntas.");
      return;
    }
    setSaving(true);
    try {
      await api.post("/progress", { session_number: sessionNumber, step: "final-review", completed: true, payload: data });
      toast.success("Revisión final guardada");
      onDone(data);
    } catch {
      toast.error("No pudimos guardar la revisión.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <p className="text-[var(--ha-muted)] leading-relaxed max-w-2xl">Reflexiona sobre tu recorrido completo en MINDHOME HEALTH APP.</p>
      <div className="mt-6 space-y-4">
        {QUESTIONS.map(q => (
          <Card key={q.key} className="rounded-2xl border-[var(--ha-border)] bg-white">
            <CardContent className="p-6">
              <div className="flex items-center gap-2 mb-3">
                <Trophy className="w-4 h-4 text-[var(--ha-secondary)]" strokeWidth={1.75} />
                <p className="font-semibold text-[var(--ha-text)]">{q.label}</p>
              </div>
              <Textarea data-testid={`fr-${q.key}`} value={data[q.key] || ""} onChange={(e) => setData({ ...data, [q.key]: e.target.value })} className="rounded-xl border-[var(--ha-border)]" />
            </CardContent>
          </Card>
        ))}
        <Card className="rounded-2xl border-[var(--ha-border)] bg-white">
          <CardContent className="p-6">
            <p className="font-semibold text-[var(--ha-text)]">Nivel general de satisfacción (1-10)</p>
            <div className="mt-3 flex items-center gap-4">
              <Slider data-testid="fr-satisfaction" value={[data.satisfaction]} onValueChange={([v]) => setData({ ...data, satisfaction: v })} min={1} max={10} step={1} className="flex-1" />
              <span className="text-sm font-bold text-[var(--ha-primary)] w-8 text-right">{data.satisfaction}</span>
            </div>
          </CardContent>
        </Card>
      </div>
      <div className="mt-8 flex justify-end">
        <Button data-testid="fr-continue" onClick={save} disabled={saving} className="rounded-full bg-[var(--ha-primary)] hover:bg-[var(--ha-primary-hover)] text-white h-11 px-6">
          Guardar <ArrowRight className="w-4 h-4 ml-1.5" strokeWidth={1.75} />
        </Button>
      </div>
    </div>
  );
}
